module.exports = __webpack_public_path__ + "static/img/cash-info-bg.001c17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/cash-info-bg.png
// module id = 7Crm
// module chunks = 215